module.exports = __webpack_public_path__ + "static/img/irole.0d81d00.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/bn/irole.png
// module id = pxsg
// module chunks = 7